import * as types from "./actionTypes";

import { IGame } from "../../types/game/Game";
import { IGameConfigurationField } from "../../types/game/GameConfiguration";
import { GenericTransport } from "../api/baseApi";
import GameApi from "../api/gameApi";

export function updateGameStarted(gameId: string) {
  return { type: types.GAMES_UPDATE_STARTED, payload: gameId };
}

export function updateGameRejected(gameId: string, error: Error) {
  return {
    type: types.GAMES_UPDATE_REJECTED,
    payload: { gameId, message: error.message, stack: error.stack },
  };
}

export function updateGameFulfilled(obj: GenericTransport<null>) {
  return { type: types.GAMES_UPDATE_FULFILLED, payload: obj };
}

export function addExtraOfficialStarted(gameId: string) {
  return { type: types.GAMES_ADDED_EXTRA_OFFICIAL_STARTED, payload: gameId };
}

export function addExtraOfficialRejected(gameId: string, message: string) {
  return {
    type: types.GAMES_ADDED_EXTRA_OFFICIAL_REJECTED,
    payload: { gameId, message },
  };
}

export function addExtraOfficialFulfilled(game: IGame) {
  return { type: types.GAMES_ADDED_EXTRA_OFFICIAL_FULLFILLED, payload: game };
}

export function removeExtraOfficialStarted(gameId: string) {
  return { type: types.GAMES_REMOVE_EXTRA_OFFICIAL_STARTED, payload: gameId };
}

export function removeExtraOfficialRejected(gameId: string, message: string) {
  return {
    type: types.GAMES_REMOVE_EXTRA_OFFICIAL_REJECTED,
    payload: { gameId, message },
  };
}

export function removeExtraOfficialFulfilled(game: IGame) {
  return { type: types.GAMES_REMOVE_EXTRA_OFFICIAL_FULLFILLED, payload: game };
}

export function removeErrorFromGame(gameId: string) {
  return (dispatch: any) =>
    dispatch({
      type: types.GAME_REMOVE_ERRORS,
      payload: gameId,
    });
}

export function updateGame(game: Partial<IGame>) {
  if (!game._id) throw new Error("Must include '_id' when updating game");

  return (dispatch: any) => {
    dispatch(updateGameStarted(game._id));
    return GameApi.updateGame(game)
      .then((resp) => {
        dispatch(updateGameFulfilled(resp));
        return resp;
      })
      .catch((er) => {
        dispatch(updateGameRejected(game._id, er));
      });
  };
}

export function addExtraOfficial(
  gameId: string,
  field: IGameConfigurationField,
  shiftId: string,
) {
  return (dispatch: any) => {
    dispatch(addExtraOfficialStarted(gameId));
    return GameApi.addExtraOfficial(gameId, field, shiftId)
      .then((game) => {
        dispatch(addExtraOfficialFulfilled(game));
        return game;
      })
      .catch((er) => {
        dispatch(addExtraOfficialRejected(gameId, er.message));
      });
  };
}

export function removeExtraOfficial(
  gameId: string,
  field: string,
  shiftSessionId: string,
) {
  return (dispatch: any) => {
    dispatch(removeExtraOfficialStarted(gameId));
    return GameApi.removeExtraOfficial(gameId, field, shiftSessionId)
      .then((game) => {
        dispatch(removeExtraOfficialFulfilled(game));
        return game;
      })
      .catch((er) => {
        dispatch(removeExtraOfficialRejected(gameId, er.message));
      });
  };
}
